import React from 'react';

import { intercomTrackEvent } from '../../../../../analytics/intercomService';
import type { ImageModalV2EditModeProps } from '../imageModalV2Types';
import ImageModalV2BackgroundEditor from './ImageModalV2BackgroundEditor';
import type { ImageModalV2OperationToastState } from '../toolbar/imageModalV2OperationToastTypes';
import type { ImageModalV2ErrorToastState } from '../toolbar/imageModalV2ErrorToastTypes';

type ImageModalV2BackgroundModeContentProps = ImageModalV2EditModeProps & {
    boundsWidth: number;
    boundsHeight: number;
    onEditorReadyChange?: (ready: boolean) => void;
    onOperationToastChange: (toast: ImageModalV2OperationToastState | null) => void;
    onErrorToastChange: (toast: ImageModalV2ErrorToastState | null) => void;
};

const ImageModalV2BackgroundModeContent: React.FC<ImageModalV2BackgroundModeContentProps> = ({
    boundsWidth,
    boundsHeight,
    finishEditingMode,
    finishEditingAfterSave,
    onEditorReadyChange,
    onOperationToastChange,
    onErrorToastChange,
    ...editModeProps
}) => {
    const closeAfterSave = (shouldWaitForViewLoad?: boolean) => {
        intercomTrackEvent('edited-image');
        if (shouldWaitForViewLoad) finishEditingAfterSave();
        else finishEditingMode();
    };

    return (
        <ImageModalV2BackgroundEditor
            {...editModeProps}
            finishEditingMode={finishEditingMode}
            finishEditingAfterSave={finishEditingAfterSave}
            editorBounds={{ width: boundsWidth, height: boundsHeight }}
            cancelEditing={finishEditingMode}
            afterSave={closeAfterSave}
            onEditorReadyChange={onEditorReadyChange}
            onOperationToastChange={onOperationToastChange}
            onErrorToastChange={onErrorToastChange}
        />
    );
};

export default ImageModalV2BackgroundModeContent;
